export default function SystemAppSideBarTooltip({showTooltip, tooltip, tooltipPos}) {
    // Used to display tooltip on mouse hovering

    // BUILD
    return (
        <div className={`fixed px-[8px] py-[4px] text-[12px] text-white
                        bg-greyLight3 rounded-[4px] whitespace-nowrap pointer-events-none
                        z-[9999] transition-opacity duration-200
                        ${showTooltip ? "opacity-100" : "opacity-0"}`}
             style={{ left: tooltipPos.x + 20, top: tooltipPos.y }}>
            {tooltip}
        </div>
    );
}